export default __webpack_public_path__ + "static/media/medal-1.3d916169.svg";